import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators,   } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
public image
  constructor( public fb: FormBuilder, public router: Router) { }


  public userForm = this.fb.group({
    Name: [''],
    userName: [''],
    mobile: [''],
    email:[''],
    password:[''],
    picture:['']
  })
  confirmPassword="";
  public chat ;
  ngOnInit(): void {
    let message = JSON.parse(localStorage.getItem("users"));
    if (message){
        this.chat= message;
    }
    else{
      this.chat=[];
    }
  }
pic(){
let img=this.userForm.value.picture
console.log(img)
let n=img.lastIndexOf('\\')
console.log(n)
img=img.slice(n+1, img.length)
console.log(img)
img=`assets/images/${img}`
console.log(img)
this.image=img

}
  submitForm(){
   
     if (this.userForm.valid){

      
      let user = this.userForm.value ; 
      user.picture=this.image
      this.chat.push(user)
      localStorage.setItem('users', JSON.stringify(this.chat));
      console.log(user);
      this.router.navigate([`login`] )
      this.chat ="";
      // this.passwordMatchingValidator;
    }  
    else{
         console.log("THE FORM IS NOT YET VALID")
       }
  }

  // passwordMatchingValidator(fb: FormBuilder): Validators{
  //  return fb.get('password').value === fb.get('confirmPassword').value ? null :
  //  {notmatched:true}; 
  // }
}
